import React, { useEffect, useState, useRef } from "react";
import {
  Divider,
  Row,
  Col,
  Spin,
  Tabs,
  Input,
  Radio,
  message,
  Checkbox,
  Alert,
  Select,
  Modal,
} from "antd";
import axios from "axios";
import api from "../../../services/forteApi";
import "./StepCheckout.css";
import CardPayment from "./CardPayment";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import CreditCardInput from "react-credit-card-input";
import { isEmpty, isNumber } from "utils/GlobalFunctions";
import BankPayment from "./BankPayment";
import NormalButton from "components/ButtonWidgets/NormalButton/NormalButton";
import StepItemWidget from "../StepFee/StepItemWidget";
import { useSelector } from "react-redux";
import StepRegItemWidget from "../StepFee/StepRegItemWidget";
import StepRegItemSummaryWidget from "../StepFee/StepRegItemSummaryWidget";


import { createToken as forteCreateToken, chargeServer as forteChargeServer } from "../../../payments/providers/ForteProvider";

const { Option } = Select;
const StepCheckoutForte = (props) => {
  const {
    appInfo,
    userData,
    setUserData,
    errorField,
    setErrorField,
    onRegister,
    onPaymentFail,
    recordList,
    regType,
    feeInfo
  } = props;
  const appDataStore = useSelector((x) => x.appDataStore);
  const [cardType, setCardType] = useState("credit");
  const [cardNumber, setCardNumber] = useState("");
  const [expiry, setExpire] = useState("");
  const [cvc, setCvc] = useState("");

  const [routingNumber, setRoutingNumber] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountType, setAccountType] = useState("c");

  const [isBusy, setIsBusy] = useState(false);
  const [dcAmount, setDcAmount] = useState(0);
  const [disCount, setDisCount] = useState("");
  const [codeValid, setCodeValid] = useState(true);
  const [allowManualPayments, setAllowManualPayments] = useState(false);
  const [hasManualPaymentCode, setHasManualPaymentCode] = useState(false);
  const [manualPaymentCodeVerified, setManualPaymentCodeVerified] = useState(false);
  const [emailInvoicesToAdmin, setEmailInvoicesToAdmin] = useState(false);
  const [forteApiLoginId, setForteApiLoginId] = useState(null);
  const [paymentModal, setPaymentModal] = useState({ visible: false, status: 'processing', message: '', error: '' });

  const forteJs = window.forte;

  useEffect(() => {
    const billFirst = userData.p_first_name || userData.camperInfo?.[0]?.camper_first_name || userData.a_first_name || "";
    const billLast = userData.p_last_name || userData.camperInfo?.[0]?.camper_last_name || userData.a_last_name || "";
    if (billFirst && billLast) {
      setUserData({ ...userData, bill_first_name: billFirst, bill_last_name: billLast })
    }
  }, [])

  // Fetch Forte api_login_id and payment settings
  useEffect(() => {
    const fetchPaymentConfig = async () => {
      try {
        const regInfo = appInfo.registration_info;
        const domain = regInfo?.domain || window.location.hostname;
        const configResponse = await axios.post(
          `${process.env.REACT_APP_API || 'https://dev.beclutch.club/api'}/camp/get_public_payment_config`,
          { domain }
        );
        if (configResponse.data.success && configResponse.data.forte_api_login_id) {
          setForteApiLoginId(configResponse.data.forte_api_login_id);
        }
      } catch (error) {
        console.error('Failed to fetch Forte payment config:', error);
      }
    };

    const fetchPaymentSettings = async () => {
      try {
        const regInfo = appInfo.registration_info;
        // For linked registrations, payment settings live on the parent registration
        const registration_id = regInfo?.registration_type === 'linked'
          ? (regInfo?.parent_registration_id || regInfo?.ID || regInfo?.id)
          : (regInfo?.ID || regInfo?.id);
        if (!registration_id) return;

        const params = new URLSearchParams();
        params.append('registration_id', registration_id);
        const response = await axios.post(
          `${process.env.REACT_APP_API || 'https://dev.beclutch.club/api'}/camp/get_registration_payment_settings`,
          params,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        if (response.data.result) {
          const d = response.data.data || response.data;
          setAllowManualPayments(!!d.allow_manual_payments);
          setHasManualPaymentCode(!!d.has_manual_payment_code);
          setEmailInvoicesToAdmin(!!d.email_invoices_to_admin);
        }
      } catch (error) {
        console.error('Failed to fetch payment settings:', error);
      }
    };

    fetchPaymentConfig();
    fetchPaymentSettings();
  }, [])
  const validateFields = () => {
    let errorList = [];
    errorList = isEmpty(userData, "bill_first_name", errorList);
    errorList = isEmpty(userData, "bill_last_name", errorList);
    errorList = isEmpty(userData, "bill_address", errorList);
    errorList = isEmpty(userData, "bill_city", errorList);
    errorList = isEmpty(userData, "bill_state", errorList);
    errorList = isEmpty(userData, "bill_postal_code", errorList);
    errorList = isEmpty(userData, "p_cell_phone", errorList);
    if (cardType == "echeck") {
      if (accountNumber == "") {
        errorList.push("account_number");
      }
      if (routingNumber == "") {
        errorList.push("routing_number");
      }
    }
    setErrorField([...errorList]);
    return errorList.length == 0;
  };

  const handleCardNumberChange = (e) => {
    setCardNumber(e.target.value);
  };
  const handleCardExpiryChange = (e) => {
    setExpire(e.target.value);
  };
  const handleCardCVCChange = (e) => {
    setCvc(e.target.value);
  };
  const onApply = async () => {
    let codeList = [];
    if (userData?.disCountInfo) {
      codeList = [...userData?.disCountInfo];
    }
    if (disCount != "") {
      let isValid = false;
      for (let i = 0; i < codeList.length; i++) {
        if (disCount == codeList[i].discount_code) {
          isValid = true;
          break;
        } else {
          isValid = false;
        }
      }
      if (isValid) {
        let disCountAmount = 0;
        let selDisInfo = codeList.filter((x) => x.discount_code == disCount)[0];
        if (parseInt(selDisInfo.discount_free) == 1) {
          disCountAmount = parseFloat(userData.total_amount);
        } else {
          if (parseFloat(selDisInfo.discount_percentage) > 0) {
            disCountAmount =
              (parseFloat(selDisInfo.discount_percentage) / 100) *
              userData.total_amount;
          } else if (parseFloat(selDisInfo.discount_amount) > 0) {
            disCountAmount = parseFloat(selDisInfo.discount_amount);
          } else {
            disCountAmount = 0;
          }
        }
        setDcAmount(disCountAmount);
        setTotalAmount(cardType, disCountAmount, disCount);
      }

      // Check if the entered code matches the manual payment code
      let manualCodeValid = false;
      if (allowManualPayments && hasManualPaymentCode) {
        try {
          const regInfo = appInfo.registration_info;
          const registration_id = regInfo?.ID || regInfo?.id;
          const params = new URLSearchParams();
          params.append('registration_id', registration_id);
          params.append('code', disCount);
          const response = await axios.post(
            `${process.env.REACT_APP_API || 'https://dev.beclutch.club/api'}/camp/verify_manual_payment_code`,
            params,
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
          );
          manualCodeValid = !!response.data?.valid;
          setManualPaymentCodeVerified(manualCodeValid);
        } catch (error) {
          setManualPaymentCodeVerified(false);
        }
      }

      // Only show invalid if neither discount code nor manual payment code matched
      setCodeValid(isValid || manualCodeValid);
    }
  };
  const onPay = async () => {
    if (isBusy) {
      return;
    }
    // if (regType == "true") {
    //   if (userData.camperInfo.length != recordList.length) {
    //     message.error(
    //       "You must upload the campers immunization record in order to proceed"
    //     );
    //     return;
    //   }
    // }
    if (parseFloat(userData.total_checkout) == 0) {
      onRegister(cardType);
    } else {
      if (!validateFields()) {
        message.error("Please confirm payment method information");
        return;
      }
      if (cardType !== "echeck") {
        if (cardNumber == "" || expiry == "" || cvc == "") {
          message.error("Please input valid payment information");
          return;
        }
      }
      onPaymentCall();
    }
  };
  const onChangeCardType = (e) => {
    console.log("onChangeCardType", e.target.value);
    setCardType(e.target.value);
    setTotalAmount(e.target.value, dcAmount, disCount);
  };
  const setTotalAmount = (e, amount, code) => {
    let processing_fee = 0;
    let countedTotal = parseFloat(
      userData.total_amount - parseFloat(amount)
    ).toFixed(2);

    if (parseFloat(countedTotal) === 0) {
      // Subtotal is $0 after discounts — no processing fee applies regardless of payment type
      processing_fee = 0;
    } else if (e == "credit") {
      const creditFee = appInfo.registration_info?.credit_fee;
      const creditMin = appInfo.registration_info?.credit_min;
      processing_fee = parseFloat(countedTotal * creditFee / 100).toFixed(2);
      if (processing_fee < creditMin) {
        processing_fee = creditMin;
      }
    } else if (e == "debit") {
      const debitType = appInfo.registration_info?.debit_flat_or_percentage;
      const debitFee = appInfo.registration_info?.debit_fee;
      const debitMin = appInfo.registration_info?.debit_min;
      if (debitType === "1" || debitType === 1) {
        processing_fee = parseFloat(debitFee).toFixed(2);
      } else {
        processing_fee = parseFloat(countedTotal * debitFee / 100).toFixed(2);
        if (debitMin && parseFloat(processing_fee) < parseFloat(debitMin)) {
          processing_fee = parseFloat(debitMin).toFixed(2);
        }
      }
    } else if (e == "echeck") {
      processing_fee = parseFloat(feeInfo?.echeck_fee || 2.0).toFixed(2);
    }

    countedTotal = parseFloat(parseFloat(countedTotal) + parseFloat(processing_fee)).toFixed(2)
    setUserData({
      ...userData,
      discount_amount: amount,
      discount_code: code,
      total_checkout: countedTotal,
      processing_fee: processing_fee,
    });
  };
  const onPaymentCall = async () => {
    if (isBusy) return;
    if (!forteApiLoginId) {
      message.error("Payment configuration not loaded. Please wait and try again.");
      return;
    }

    let paymentData = { api_login_id: forteApiLoginId };
    if (cardType == "echeck") {
      paymentData = {
        ...paymentData,
        account_number: accountNumber,
        routing_number: routingNumber,
        account_type: accountType,
      };
    } else {
      paymentData = {
        ...paymentData,
        card_number: cardNumber.replace(/\s/g, ""),
        expire_year: "20" + expiry.split(" / ")[1],
        expire_month: expiry.split(" / ")[0],
        cvv: cvc,
      };
    }
    try {
      setIsBusy(true);
      const token = await forteCreateToken(forteJs, paymentData);
      await onCallTransaction(token);
    } catch (err) {
      setIsBusy(false);
      onPaymentFail(cardType, err.message, "token_api");
      message.error("Payment failed on one time token generating. " + err.message);
    }
  };

  const onCallTransaction = async (token) => {
    try {
      setIsBusy(true);
      const credit_min_fee = parseFloat(appInfo.registration_info?.credit_min);
      // Only apply the minimum when the subtotal is non-zero; a $0 order has no processing fee
      const service_fee_amount = parseFloat(userData.processing_fee) === 0
        ? 0
        : (parseFloat(userData.processing_fee) < credit_min_fee ? credit_min_fee : userData.processing_fee);

      const payload = {
        domain: appInfo.registration_info?.domain,
        registration_id: appInfo.registration_info?.ID,
        merchant: appInfo.registration_info?.merchant,
        authorization_amount: userData.total_checkout,
        service_fee_amount,
        billing_address: {
          first_name: userData.bill_first_name,
          last_name: userData.bill_last_name,
          address: userData.bill_address,
          city: userData.bill_city,
          state: userData.bill_state,
          postal_code: userData.bill_postal_code,
        },
        card_type: cardType === "echeck" ? "echeck" : "card",
        token,
      };

      const res = await forteChargeServer(payload);

      setIsBusy(false);
      if (res?.result && res?.data) {
        const d = res.data;
        onRegister(
          cardType,
          d.transaction_id,
          d.entered_by,
          d.authorization_code,
          d.location_id
        );
      } else {
        onPaymentFail(cardType, JSON.stringify(res), "transaction_api");
        message.error("Payment Failed.");
      }
    } catch (err) {
      setIsBusy(false);
      message.error("Payment Failed.");
      onPaymentFail(cardType, err.message, "transaction_api");
    }
  };

  const onDropOffPayment = async () => {
    if (isBusy) return;
    setIsBusy(true);

    // Show processing modal immediately
    setPaymentModal({ visible: true, status: 'processing', message: 'Processing Drop-Off Registration...', error: '' });

    try {
      const registration_id = appInfo.registration_info?.ID || appInfo.registration_info?.id;
      if (!registration_id) {
        throw new Error('Registration ID not found');
      }

      const manualTotalCheckout = parseFloat(
        (parseFloat(userData.total_amount || 0) - parseFloat(userData.discount_amount || 0)).toFixed(2)
      );

      const payload = {
        registration_id,
        manual_payment_code: disCount,
        ...userData,
        processing_fee: 0,
        total_checkout: manualTotalCheckout,
      };

      // Call the manual payment endpoint
      const response = await axios.post(
        `${process.env.REACT_APP_API || 'https://dev.beclutch.club/api'}/camp/manual_payment_registration`,
        payload
      );

      if (response.data && response.data.success) {
        // Show success for 1.5s then call onRegister
        setPaymentModal({
          visible: true,
          status: 'success',
          message: 'Invoice Sent Successfully!',
          error: ''
        });

        setTimeout(() => {
          setIsBusy(false);
          setPaymentModal({ visible: false, status: 'processing', message: '', error: '' });
          // Call onRegister with manual payment method
          onRegister("manual", response.data.transaction_id || "", response.data.customer_id || "");
        }, 1500);
      } else {
        throw new Error(response.data?.message || 'Failed to process drop-off payment');
      }
    } catch (err) {
      setIsBusy(false);

      const errorDetail = err.response?.data?.msg ||
        err.response?.data?.message ||
        err.message ||
        "Drop-off registration failed";

      console.error("Drop-off payment error:", err);

      setPaymentModal({
        visible: true,
        status: 'error',
        message: 'Drop-Off Registration Failed',
        error: errorDetail
      });
    }
  };

  console.log('userData', userData);
  console.log('appInfo', appInfo);

  return (
    <div className="profile-info-widget">
      <div>
        <span className="title" style={{ fontSize: 17 }}>
          {appInfo.registration_info?.registration_name} Fees
        </span>
        <Divider></Divider>
      </div>
      {userData.camperInfo.filter((f) => f.sel_reg_id.length != 0).length > 0 &&
        <div style={{ marginTop: 20 }} className="block">
          <span className="title" style={{ fontSize: 17 }}>
            Participant Registration
          </span>
          <Divider></Divider>
          {userData.camperInfo.map((camper, key) => {
            return (
              <div key={key}>
                <div
                  style={{
                    fontSize: 16,
                    marginTop: 10,
                  }}
                >
                  {camper?.camper_first_name && camper?.camper_last_name ?
                    camper?.camper_first_name + " " + camper?.camper_last_name + " Registration" : userData?.p_first_name && userData?.p_last_name ? userData?.p_first_name + " " + userData?.p_last_name + " Registration" : "Participant " + (key + 1) + " Registration"}
                </div>
                <div>
                  {userData.camperInfo[key].sel_reg_id.map((x, index) => {
                    return <StepRegItemSummaryWidget
                      itemInfo={x}
                      key={index}
                      userData={userData}
                    />;
                  })}
                </div>
              </div>
            );
          })}
        </div>}
      {userData.camperInfo.filter((f) => f.sel_trip != "").length > 0 &&
        <div style={{ marginTop: 20 }} className="block">
          <span className="title" style={{ fontSize: 17 }}>
            Extra Program Fees
          </span>
          <Divider></Divider>
          {userData.camperInfo.map((camper, key) => {
            return (
              <div key={key}>
                <div
                  style={{
                    fontSize: 16,
                    marginTop: 10,
                  }}
                >
                  {camper?.camper_first_name && camper?.camper_last_name ?
                    camper?.camper_first_name + " " + camper?.camper_last_name + " Extra Programs" : userData?.p_first_name && userData?.p_last_name ? userData?.p_first_name + " " + userData?.p_last_name + " Extra Programs" : "Participant " + (key + 1) + " Extra Programs"}
                </div>
                <div>
                  {userData.tripList.map((x, index) => {
                    return userData.camperInfo[key].sel_trip.includes(x.id + ",") ? (
                      <StepItemWidget
                        itemInfo={x}
                        key={index}
                        camperIndex={key}
                        isLast={index == userData.tripList.length - 1}
                        userData={userData}
                      />
                    ) : (
                      <div key={index}></div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      }
      {userData.disCountInfo.length > 0 &&
        <Row
          justify="space-between"
          align="middle"
          gutter={[64, 8]}
          className="discount-rect"
        >
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px" }}>Discount Code</div>
            <Input
              value={disCount}
              className={`common-input`}
              onChange={(e) => {
                setDisCount(e.target.value);
              }}
            />
            <div className="discount-valid">
              {!codeValid && disCount != "" && (
                <span>Error: Discountcode Invalid</span>
              )}
            </div>
          </Col>
          <Col xs={24} sm={12}>
            <CommonButton
              style={
                disCount != ""
                  ? {
                    backgroundColor: "#7fb522",
                    cursor: "pointer",
                    lineHeight: "34px",
                  }
                  : {
                    backgroundColor: "#878787",
                    cursor: "no-drop",
                    lineHeight: "34px",
                  }
              }
              onClick={() => onApply()}
            >
              Apply
            </CommonButton>
          </Col>
        </Row>
      }
      <div style={{ marginTop: 30 }}>
        <span className="title">Confirm Payment and Finish Checkout</span>
        <Divider></Divider>
        <div>
          <Row gutter={16} style={{ marginTop: 20 }}>
            <Col xs={24} sm={12}>
              <div style={{ paddingBottom: "5px" }}>Billing First Name*</div>
              <Input
                value={userData.bill_first_name}
                className={
                  errorField !== undefined &&
                    errorField.includes("bill_first_name")
                    ? `common-input-error`
                    : `common-input`
                }
                onChange={(e) => {
                  if (errorField.includes("bill_first_name")) {
                    let errors = errorField.filter((x) => x != "bill_first_name");
                    setErrorField([...errors]);
                  }
                  setUserData({ ...userData, bill_first_name: e.target.value });
                }}
              />
            </Col>
            <Col xs={24} sm={12}>
              <div style={{ paddingBottom: "5px" }}>Billing Last Name*</div>
              <Input
                value={userData.bill_last_name}
                className={
                  errorField !== undefined &&
                    errorField.includes("bill_last_name")
                    ? `common-input-error`
                    : `common-input`
                }
                onChange={(e) => {
                  if (errorField.includes("bill_last_name")) {
                    let errors = errorField.filter((x) => x != "bill_last_name");
                    setErrorField([...errors]);
                  }
                  setUserData({ ...userData, bill_last_name: e.target.value });
                }}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
            <Col xs={24} sm={12}>
              <div style={{ paddingBottom: "5px" }}>Billing Address*</div>
              <Input
                value={userData.bill_address}
                className={
                  errorField !== undefined &&
                    errorField.includes("bill_address")
                    ? `common-input-error`
                    : `common-input`
                }
                onChange={(e) => {
                  if (errorField.includes("bill_address")) {
                    let errors = errorField.filter((x) => x != "bill_address");
                    setErrorField([...errors]);
                  }
                  setUserData({ ...userData, bill_address: e.target.value });
                }}
              />
            </Col>
            <Col xs={24} sm={12}>
              <div style={{ paddingBottom: "5px" }}>Billing City*</div>
              <Input
                value={userData.bill_city}
                className={
                  errorField !== undefined && errorField.includes("bill_city")
                    ? `common-input-error`
                    : `common-input`
                }
                onChange={(e) => {
                  if (errorField.includes("bill_city")) {
                    let errors = errorField.filter((x) => x != "bill_city");
                    setErrorField([...errors]);
                  }
                  setUserData({ ...userData, bill_city: e.target.value });
                }}
              />
            </Col>
          </Row>
          <Row gutter={16} style={{ marginTop: 20 }}>
            <Col xs={24} sm={8}>
              <div style={{ paddingBottom: "5px" }}>
                Billing State/Province*
              </div>
              <Select
                showSearch
                className={
                  errorField !== undefined && errorField.includes("bill_state")
                    ? `common-select-error`
                    : `common-select`
                }
                value={
                  userData.bill_state == undefined ? null : userData.bill_state
                }
                onSelect={(v) => {
                  if (errorField.includes("bill_state")) {
                    let errors = errorField.filter((x) => x != "bill_state");
                    setErrorField([...errors]);
                  }
                  setUserData({ ...userData, bill_state: v });
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                <Option value="AL">Alabama</Option>
                <Option value="AK">Alaska</Option>
                <Option value="AZ">Arizona</Option>
                <Option value="AR">Arkansas</Option>
                <Option value="CA">California</Option>
                <Option value="CO">Colorado</Option>
                <Option value="CT">Connecticut</Option>
                <Option value="DE">Delaware</Option>
                <Option value="FL">Florida</Option>
                <Option value="GA">Georgia</Option>
                <Option value="HI">Hawaii</Option>
                <Option value="ID">Idaho</Option>
                <Option value="IL">Illinois</Option>
                <Option value="IN">Indiana</Option>
                <Option value="IA">Iowa</Option>
                <Option value="KS">Kansas</Option>
                <Option value="KY">Kentucky</Option>
                <Option value="LA">Louisiana</Option>
                <Option value="ME">Maine</Option>
                <Option value="MD">Maryland</Option>
                <Option value="MA">Massachusetts</Option>
                <Option value="MI">Michigan</Option>
                <Option value="MN">Minnesota</Option>
                <Option value="MS">Mississippi</Option>
                <Option value="MO">Missouri</Option>
                <Option value="MT">Montana</Option>
                <Option value="NE">Nebraska</Option>
                <Option value="NV">Nevada</Option>
                <Option value="NH">New Hampshire</Option>
                <Option value="NJ">New Jersey</Option>
                <Option value="NM">New Mexico</Option>
                <Option value="NY">New York</Option>
                <Option value="NC">North Carolina</Option>
                <Option value="ND">North Dakota</Option>
                <Option value="OH">Ohio</Option>
                <Option value="OK">Oklahoma</Option>
                <Option value="OR">Oregon</Option>
                <Option value="PA">Pennsylvania</Option>
                <Option value="RI">Rhode Island</Option>
                <Option value="SC">South Carolina</Option>
                <Option value="SD">South Dakota</Option>
                <Option value="TN">Tennessee</Option>
                <Option value="TX">Texas</Option>
                <Option value="UT">Utah</Option>
                <Option value="VT">Vermont</Option>
                <Option value="VA">Virginia</Option>
                <Option value="WA">Washington</Option>
                <Option value="WV">West Virginia</Option>
                <Option value="WI">Wisconsin</Option>
                <Option value="WY">Wyoming</Option>
              </Select>
            </Col>
            <Col xs={24} sm={8}>
              <div style={{ paddingBottom: "5px" }}>
                Billing Zip/Postal Code*
              </div>
              <Input
                value={userData.bill_postal_code}
                className={
                  errorField !== undefined &&
                    errorField.includes("bill_postal_code")
                    ? `common-input-error`
                    : `common-input`
                }
                onChange={(e) => {
                  if (errorField.includes("bill_postal_code")) {
                    let errors = errorField.filter(
                      (x) => x != "bill_postal_code"
                    );
                    setErrorField([...errors]);
                  }
                  setUserData({
                    ...userData,
                    bill_postal_code: e.target.value,
                  });
                }}
              />
            </Col>
            <Col xs={24} sm={8}>
              <div style={{ paddingBottom: "5px" }}>Billing Phone Number*</div>
              <Input
                type="text"
                value={userData.p_cell_phone}
                placeholder="___-___-____"
                className={
                  errorField !== undefined &&
                    errorField.includes("p_cell_phone")
                    ? `common-input-error`
                    : `common-input`
                }
                onChange={(e, w) => {

                  let str = e.target.value;
                  let filStr = str.replace(/[- ]/g, "");
                  let tmpPhone = "";
                  if (filStr == "" || filStr.length == 0) {
                    setUserData({
                      ...userData, p_cell_phone: ""
                    });

                    return;
                  }
                  if (!isNumber(filStr)) {
                    return;
                  }
                  if (filStr.length > 10) {
                    return;
                  }

                  if (errorField.includes("p_cell_phone")) {
                    let errors = errorField.filter(
                      (y) => y != "p_cell_phone"
                    );
                    setErrorField([...errors]);
                  }

                  if (filStr.length > 3 && filStr.length < 7) {
                    str = filStr.slice(0, 3) + "-" + filStr.slice(3);
                  }

                  if (filStr.length > 6) {
                    str =
                      filStr.slice(0, 3) +
                      "-" +
                      filStr.slice(3, 6) +
                      "-" +
                      filStr.slice(6);
                  }
                  setUserData({
                    ...userData, p_cell_phone: str
                  });
                }}
              />
            </Col>
          </Row>
        </div>
        <div style={{ marginTop: 20, marginLeft: 20 }}>
          <Radio.Group
            onChange={(e) => {
              onChangeCardType(e);
            }}
            value={cardType}
          >
            <Radio value={"credit"}>Credit Card({appInfo.registration_info?.credit_fee}%)</Radio>
            <Radio value={"debit"}>
              Debit Card ({appInfo.registration_info?.debit_fee}%)
            </Radio>
            {userData.processing_echeck_fee > 0 && (
              <Radio value={"echeck"}>eCheck (${parseFloat(userData.processing_echeck_fee).toFixed(2)})</Radio>
            )}
          </Radio.Group>
        </div>
      </div>
      {cardType == "echeck" ? (
        <div className="block">
          <Row gutter={16}>
            <Col xs={24} sm={10}>
              <div style={{ paddingBottom: "5px" }}>Rounting Number*</div>
              <Input
                value={routingNumber}
                className={
                  errorField !== undefined &&
                    errorField.includes("routing_number")
                    ? `common-input-error`
                    : `common-input`
                }
                onChange={(e) => {
                  if (errorField.includes("routing_number")) {
                    let errors = errorField.filter(
                      (x) => x != "routing_number"
                    );
                    setErrorField([...errors]);
                  }
                  setRoutingNumber(e.target.value);
                }}
              />
            </Col>
            <Col xs={24} sm={10}>
              <div style={{ paddingBottom: "5px" }}>Account Number*</div>
              <Input
                value={accountNumber}
                className={
                  errorField !== undefined &&
                    errorField.includes("account_number")
                    ? `common-input-error`
                    : `common-input`
                }
                onChange={(e) => {
                  if (errorField.includes("account_number")) {
                    let errors = errorField.filter(
                      (x) => x != "account_number"
                    );
                    setErrorField([...errors]);
                  }
                  setAccountNumber(e.target.value);
                }}
              />
            </Col>
            <Col xs={24} sm={4}>
              <div style={{ paddingBottom: "5px" }}>Account Type</div>
              <Select
                showSearch
                className={
                  errorField !== undefined &&
                    errorField.includes("account_type")
                    ? `common-select-error`
                    : `common-select`
                }
                value={accountType}
                onSelect={(v) => {
                  if (errorField.includes("account_type")) {
                    let errors = errorField.filter((x) => x != "account_type");
                    setErrorField([...errors]);
                  }
                  setAccountType(v);
                }}
              >
                <Option value="c">Checking</Option>
                <Option value="s">Savings</Option>
              </Select>
            </Col>
          </Row>
        </div>
      ) : (
        <div className="block">
          <CreditCardInput
            cardNumberInputProps={{
              value: cardNumber,
              onChange: handleCardNumberChange,
            }}
            cardExpiryInputProps={{
              value: expiry,
              onChange: handleCardExpiryChange,
            }}
            cardCVCInputProps={{ value: cvc, onChange: handleCardCVCChange }}
            fieldClassName="input"
          />
        </div>
      )}
      <div style={{ marginTop: 30 }}>
        <span className="title">Order Summary</span>
        <Divider></Divider>
      </div>
      <div className="block">
        <Row
          style={{
            marginTop: 10,
            paddingLeft: 20,
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <Col flex={"auto"}>Registration Fees</Col>
          <Col flex={"180px"}>${Number(userData.src_total_amount).toFixed(2)}</Col>
        </Row>
        {parseFloat(userData.early_reg_discount_amount_applied || 0) > 0 && (
          <Row
            style={{
              marginTop: 20,
              paddingLeft: 20,
              paddingTop: 10,
              paddingBottom: 10,
              color: "var(--redColor)",
            }}
          >
            <Col flex={"auto"}>Early Registration</Col>
            <Col flex={"185px"}>-${Number(userData.early_reg_discount_amount_applied).toFixed(2)}</Col>
          </Row>
        )}
        {parseFloat(userData.late_reg_fee_amount_applied || 0) > 0 && (
          <Row
            style={{
              marginTop: 20,
              paddingLeft: 20,
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            <Col flex={"auto"}>Late Registration Fee</Col>
            <Col flex={"185px"}>${Number(userData.late_reg_fee_amount_applied).toFixed(2)}</Col>
          </Row>
        )}
        {codeValid && disCount != "" && (
          <Row
            style={{
              marginTop: 20,
              paddingLeft: 20,
              paddingTop: 10,
              paddingBottom: 10,
              color: "var(--redColor)",
            }}
          >
            <Col flex={"auto"}>Registration Discount</Col>
            <Col flex={"185px"}>-${Number(userData.discount_amount).toFixed(2)}</Col>
          </Row>
        )}
        <Row
          style={{
            marginTop: 20,
            paddingLeft: 20,
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <Col flex={"auto"}>Processing Fees</Col>
          <Col flex={"180px"}>${Number(userData.processing_fee).toFixed(2)}</Col>
        </Row>
        <Row
          style={{
            marginTop: 20,
            background: "var(--mainColor)",
            padding: 20,
            color: "var(--whiteColor)",
          }}
          justify={"center"}
        >
          <Col flex={"auto"}>Checkout Total</Col>
          <Col flex={"180px"} style={{ paddingLeft: 20, fontSize: 16 }}>
            ${Number(userData.total_checkout).toFixed(2)}
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: 50, marginBottom: 30, textAlign: "center" }}>
        <NormalButton
          style={{ backgroundColor: "#7fb522", cursor: "pointer" }}
          onClick={() => {
            onPay();
          }}
          isBusy={isBusy}
        >
          {parseFloat(userData.total_checkout) == 0
            ? "Register"
            : "Pay $" + Number(userData.total_checkout).toFixed(2)}
        </NormalButton>
        
        {allowManualPayments && hasManualPaymentCode && manualPaymentCodeVerified && (
          <div style={{ marginTop: 15 }}>
            <NormalButton
              style={{ backgroundColor: "#FF8C00", cursor: "pointer" }}
              onClick={() => {
                onDropOffPayment();
              }}
              isBusy={isBusy}
            >
              Drop Off Payment
            </NormalButton>
          </div>
        )}
      </div>

      {/* Payment Processing Modal */}
      <Modal
        visible={paymentModal.visible}
        closable={paymentModal.status !== 'processing'}
        footer={null}
        onCancel={() => setPaymentModal({ visible: false, status: 'processing', message: '', error: '' })}
        bodyStyle={{ borderRadius: '12px', padding: '24px' }}
        style={{ borderRadius: '12px' }}
      >
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          {paymentModal.status === 'processing' && (
            <>
              <Spin size="large" />
              <div style={{ marginTop: 20, fontSize: 18, fontWeight: 500 }}>
                {paymentModal.message}
              </div>
            </>
          )}
          
          {paymentModal.status === 'success' && (
            <>
              <div style={{ fontSize: 48, color: '#52c41a', marginBottom: 16 }}>✓</div>
              <div style={{ fontSize: 18, fontWeight: 500, color: '#52c41a' }}>
                {paymentModal.message}
              </div>
            </>
          )}
          
          {paymentModal.status === 'error' && (
            <>
              <div style={{ fontSize: 48, color: '#ff4d4f', marginBottom: 16 }}>✕</div>
              <div style={{ fontSize: 18, fontWeight: 500, color: '#ff4d4f', marginBottom: 12 }}>
                {paymentModal.message}
              </div>
              {paymentModal.error && (
                <div style={{ 
                  fontSize: 14, 
                  color: '#666', 
                  padding: '12px', 
                  background: '#f5f5f5', 
                  borderRadius: '4px',
                  wordBreak: 'break-word'
                }}>
                  {paymentModal.error}
                </div>
              )}
              <div style={{ marginTop: 20 }}>
                <CommonButton 
                  onClick={() => setPaymentModal({ visible: false, status: 'processing', message: '', error: '' })}
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Close
                </CommonButton>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default StepCheckoutForte;
